import { Navigate, useLocation } from 'react-router-dom';
import { RoutePaths } from '../../config/routes';
import { useAuth } from '../../hooks/useAuth';
export var RequireAuth = function (_a) {
    var children = _a.children;
    var isAuthenticated = useAuth().isAuthenticated;
    var location = useLocation();
    if (!isAuthenticated()) {
        return (<Navigate to={RoutePaths.SIGN_IN} state={{ from: location, expiredSession: true }} replace/>);
    }
    return children;
};
export var RequireAnonymous = function (_a) {
    var children = _a.children;
    var isAuthenticated = useAuth().isAuthenticated;
    var location = useLocation();
    if (isAuthenticated()) {
        return <Navigate to={RoutePaths.DASHBOARD} state={{ from: location }} replace/>;
    }
    return children;
};
